import { Box, Stack } from "@mui/material";
import { PaymentProgressIndicator } from "Components/Merchant/InitiatePaymentDetail/PaymentProgressIndicator/PaymentProgressIndicator";
import { Amount } from "Components/Merchant/InitiatePaymentDetail/shared/Amount";
import { TransactionID } from "Components/Merchant/InitiatePaymentDetail/shared/TransactionID";
import type { TransactionStatus } from "Infrastructure/Api/Api";
import type { ReactNode } from "react";

type Props = {
  transactionStatus: TransactionStatus;
  children: ReactNode;
  actionsSection: ReactNode;
  amount: number;
  currencyCode: string;
  transactionPublicID: string;
};

//Note: The hardcoded height/margin values are used to ensure the main parts of the layout (progress indicator, amount, text...) are aligned correctly between different payment statuses.
export const PaymentLayout = ({
  transactionStatus,
  children,
  actionsSection,
  amount,
  currencyCode,
  transactionPublicID,
}: Props) => (
  <Stack
    flex={1}
    gap={[5, 10]}
    height="100%"
    textAlign="center"
    alignItems="center"
    justifyContent="space-between"
  >
    <Box px={[5, 20]} mt="3%" width="100%">
      <PaymentProgressIndicator transactionStatus={transactionStatus} />
    </Box>
    <Box height="210px" width="100%">
      {children}
    </Box>
    <Stack gap={[1, 4]}>
      <Amount currencyCode={currencyCode} amount={amount} />
      <TransactionID publicID={transactionPublicID} />
    </Stack>
    <Box
      px={[3, 15]}
      width="100%"
      height="95px"
      display="flex"
      alignItems="flex-end"
    >
      {actionsSection}
    </Box>
  </Stack>
);
